module.exports = {"370112001":"山大路街道","370112002":"洪家楼街道","370112003":"东风街道","370112004":"全福街道","370112005":"孙村街道","370112006":"巨野河街道","370112007":"华山街道","370112008":"荷花路街道","370112009":"王舍人街道","370112010":"鲍山街道","370112011":"郭店街道","370112012":"唐冶街道","370112013":"港沟街道","370112014":"遥墙街道","370112015":"临港街道","370112101":"仲宫镇","370112103":"柳埠镇","370112106":"董家镇","370112107":"唐王镇","370112111":"西营镇","370112112":"彩石镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370112.json
// module id = 1254
// module chunks = 0